import { ValueOf } from '@doda/common/src/utils/typeUtil';

export const PAGES = {
  CAREER_RECOMMEND_JOB_LIST: 'CareerRecommendJobList',
  TOP: 'Top',
  INTENTION_JOB_LIST: 'IntentionJobList',
  JOB_SEARCH_DETAIL: 'JobSearchDetail',
  JOB_SEARCH_LIST: 'JobSearchList',
  JOB_HISTORY_LIST: 'JobHistoryList',
  MATCH_JOB_LIST: 'MatchJobList',
  FEATURED_JOB_LIST: 'FeaturedJobList',
  CONDITION_CHANGE: 'ConditionChange',
  RECOMMEND_JOB_LIST: 'RecommendJobList',
  SELECT_JOB_LIST: 'SelectJobList',
  STATION_LIST: 'StationList',
  ROUTE_LIST: 'RouteList',
  QUALIFICATION_LIST: 'QualificationList',
  NEW_JOB_LIST: 'NewJobList',
  JOB_SEARCH_TOP: 'JobSearchTop',
  EVENT_DETAIL_DISPLAY: 'EventDetailDisplay',
  NONE: 'none',
  JOB_TREND: 'JobTrend',
  JOB_RANKING: 'JobRanking',
} as const;

export type PageType = ValueOf<typeof PAGES>;
